import { mount } from "svelte";
import HomepageHeroElement from "$js/components/organisms/homepage-hero/homepage-hero.svelte";

export class HomepageHero {
    target: HTMLElement | null = document.querySelector('.js-homepage-hero');

    constructor() {
        if (!this.target) {
            return;
        }

        mount(HomepageHeroElement, {
            target: this.target
        });
    }
}